import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const CandidateDetailsWrapper = styled(Box)({
  padding: "24px",
  background: "linear-gradient(180deg, #fef2f2 0%, #fef2f2 100%)",
  minHeight: "100%",

  "& .page-header": {
    marginBottom: "24px",
  },

  "& .page-title": {
    fontSize: "28px",
    fontWeight: 700,
    color: colors.primary,
    lineHeight: 1.2,
    marginBottom: "6px",
  },

  "& .page-subtitle": {
    fontSize: "14px",
    color: "#637381",
    lineHeight: 1.5,
  },

  "& .form-card": {
    background: "#ffffff",
    border: "1px solid #dde7f0",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(127, 29, 29, 0.06)",
    overflow: "hidden",
  },

  "& .form-card__body": {
    padding: "32px",
  },

  "& .section-title": {
    fontSize: "18px",
    fontWeight: 700,
    color: colors.primary,
    marginBottom: "24px",
  },

  "& .section-divider": {
    margin: "32px 0",
    borderColor: "#e8ecf0",
  },

  "& .field-label": {
    fontSize: "13px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
  },

  "& .text-field .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#d6e0ea",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "1.5px",
    },
  },

  "& .text-field .MuiInputAdornment-root": {
    color: "#919eab",
  },

  "& .footer-bar": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 32px",
    background: colors.primaryLight,
    borderTop: "1px solid #dde7f0",
  },

  "& .cancel-btn": {
    textTransform: "none",
    borderRadius: "12px",
    padding: "10px 28px",
    fontWeight: 600,
    fontSize: "14px",
    color: "#374151",
    borderColor: "#d6e0ea",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: colors.primary,
      backgroundColor: colors.primaryLight,
    },
  },

  "& .save-btn": {
    textTransform: "none",
    borderRadius: "12px",
    padding: "10px 28px",
    fontWeight: 600,
    fontSize: "14px",
    backgroundColor: colors.primary,
    color: "#fff",
    boxShadow: "0 8px 18px rgba(127, 29, 29, 0.18)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: "0 10px 22px rgba(127, 29, 29, 0.22)",
    },
  },

  "@media (max-width: 900px)": {
    padding: "16px",

    "& .form-card__body": {
      padding: "20px",
    },

    "& .footer-bar": {
      padding: "16px 20px",
    },
  },
});
